import { zodResolver } from '@hookform/resolvers/zod';
import {
  isValidSocialSecurityNumber,
  SOCIAL_SECURITY_NUMBER_INVALID_MESSAGE,
} from '@omecare/utils';
import { z } from 'zod';

const REQUIRED_MESSAGE = 'form.errors.required';

const requiredString = z
  .string({ message: REQUIRED_MESSAGE })
  .min(1, { message: REQUIRED_MESSAGE });

/**
 * Schema for the medical assistant self-service profile form.
 *
 * Fields are required HERE (frontend) even though the API accepts them as
 * optional/nullable: the product wants assistants to complete their profile,
 * but the backend stays lenient so partial records (e.g. from imports) remain
 * valid. `addressLine2` and `addressState` (country) are the only optional
 * fields.
 */
export const assistantProfileFormSchema = z.object({
  firstname: requiredString,
  lastname: requiredString,
  phone: requiredString,
  dateOfBirth: requiredString,
  birthPlace: requiredString,
  nationality: requiredString,
  socialSecurityNumber: requiredString.refine(isValidSocialSecurityNumber, {
    message: SOCIAL_SECURITY_NUMBER_INVALID_MESSAGE,
  }),
  addressLine1: requiredString,
  addressLine2: z.string().optional(),
  addressPostalCode: requiredString,
  addressCity: requiredString,
  addressState: z.string().optional(),
});

export type AssistantProfileFormValues = z.infer<
  typeof assistantProfileFormSchema
>;

export const assistantProfileFormResolver = zodResolver(
  assistantProfileFormSchema,
);
